export enum CartConstantsEnum {
  CartReqVersion = 'cartReqVersion',
  CartId = 'cartId',
  ListId = 'listId',
  CartObj = 'CartObj',
  CheckoutCartEntries = 'CheckoutCartEntries',
  AnonymousUser = 'anonymousUser',
  SubCartID = 'SubCartID',
  WarehouseId = 'warehouseId',
  Cart = 'cart',
  List = 'list',
  IsGroupCart = 'isGroupCart',
  MyShopExists = 'myShopExists',
  CheckoutProfile = 'checkoutProfile',
  MergeCartCompleted = 'MergeCartCompleted',
}

export enum MyShopStorageConstant {
  SHARECODEATTRIBUTES = 'sharecodeAttributes',
}

export enum ApiProjections {
  DETAILED = 'DETAILED',
  MIN = 'MIN',
  FULL = 'FULL',
}

export enum RationingMessages {
  DAILY = 'DAILY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  LIFETIME = 'LIFETIME',
}

export enum RationingCallBack {
  REMOVE = 'REMOVE',
  UPDATE = 'UPDATE',
}
export enum RationingRibbonType {
  ERROR = 'ERROR',
  INFO = 'INFO',
}

export enum MessageType {
  REMAININGLIMIT = 'REMAININGLIMIT',
}

export enum KeyboardKeys {
  ENTER = 'Enter',
}

export enum CTAEventType {
  CLICK = 'click',
}

export enum CartAPIMethodArray {
  getCart = 'getCart',
  getMiniCart = 'getMiniCart',
  changeQtyForEntryFromCart = 'changeQtyForEntryFromCart',
  removeEntryFromCart = 'removeEntryFromCart',
  getCarts = 'getCarts',
  createCart = 'createCart',
  addToCart = 'addToCart',
  deleteCart = 'deleteCart',
  clearCartEntries = 'clearCartEntries',
  updateCartEntries = 'updateCartEntries',
  getProfiles = 'getProfiles',
  addToCartGCO = 'addToCartGCO',
  updateGCOFlag = 'updateGCOFlag',
  createSubCart = 'createSubCart',
  deleteSubCart = 'deleteSubCart',
  reassignCart = 'reassignCart',
  getSubCart = 'getSubCart',
}

export enum InvalidProductException {
  INVALID_PRODUCT = 'INVALID PRODUCT',
}

export enum SWITCH_PROXY_TYPE {
  OVERRIDE = 'OVERRIDE',
  SWITCH = 'SWITCH',
}

export enum CartDeliveryType {
  BOPIS = 'bopis',
}

export default CartConstantsEnum;
